import React, { useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { FaCoins } from "react-icons/fa";
import { FiCheckCircle, FiTarget } from "react-icons/fi";

function ProblemSet() {
  const navigate = useNavigate();
  const { contest } = useSelector((state) => state.competitions);
  const go = useCallback(
    (challengeId) =>
      navigate(`/compete/${contest?.contest?.tag}/${challengeId}`),
    [navigate, contest?.contest?.tag]
  );

  const renderStatusIcon = (status) => {
    switch (status) {
      case "Accepted":
        return <FiCheckCircle className="text-lime-400" />;
      case "Attempted":
        return <FiTarget className="text-yellow-400" />;
      default:
        return null;
    }
  };

  if (!contest?.challenges || contest.challenges.length === 0) {
    return <div className="text-yellow-400">No peeking :)</div>;
  }

  return (
    <div className="max-h-96 overflow-y-auto">
      <table className="w-full">
        <thead className="border-b border-zinc-700 sticky top-0 bg-zinc-900/90 backdrop-blur z-10">
          <tr>
            <th className="pb-2 pt-1 text-left text-orange-400 font-medium w-10">#</th>
            <th className="pb-2 pt-1 text-left text-orange-400 font-medium">NAME</th>
            <th className="pb-2 pt-1 text-center text-orange-400 font-medium">STATUS</th>
            <th className="pb-2 pt-1 text-right text-orange-400 font-medium">POINTS</th>
          </tr>
        </thead>
        <tbody>
          {contest?.challenges?.map((challenge, index) => (
            <tr
              key={index}
              onClick={() => go(challenge._id)}
              className="border-b border-zinc-800 last:border-0 hover:bg-zinc-800/30 transition-colors cursor-pointer"
            >
              <td className="py-2 text-zinc-400">{challenge?.order}</td>
              <td className="py-2 text-zinc-300">{challenge?.name}</td>
              <td className="py-2 text-center">
                {renderStatusIcon(challenge?.challengeStatus)}
              </td>
              <td className="py-2 text-right flex items-center justify-end">
                <span className="text-yellow-400">{challenge?.points}</span>
                <FaCoins className="ml-2 text-yellow-400" />
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default ProblemSet;